import { Injectable, OnDestroy } from '@angular/core';
import { take } from 'rxjs/operators';
import { GlobalDataContextService } from 'src/app/global-data-context.service';
import { UserDataContextService_FetchGQL } from 'src/graphql/generated/graphql.generated';
import { StoreService } from 'src/store/store.service';
import { Subject } from 'rxjs';
import { firstValueOrUndefined } from 'src/util/rxjs';
import { filterNull } from 'src/util/rxjs/operators/filter-null';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class UserDataContextService implements OnDestroy {
  private _initialized = false;
  private _onDestroy$ = new Subject();

  constructor(
    private _store: StoreService,
    private _gql: UserDataContextService_FetchGQL,
    private _auth: AuthenticationService,
    private _global: GlobalDataContextService,
  ) {}

  public async syncUserData() {
    return firstValueOrUndefined(this._fetch().pipe(take(1)));
  }

  public init() {
    if (this._initialized) {
      return;
    }

    this._auth.accessClaims$.pipe(filterNull(), take(1)).subscribe(async () => {
      // This GQL fetches both the user context and other data needed for
      // authorization/navigation (e.g. company data) on initial site load
      await firstValueOrUndefined(this._global.fetch().pipe(take(1)));
    });

    this._initialized = true;
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next(null);
    this._onDestroy$.complete();
  }

  private _fetch() {
    return this._store.upsertEntitiesFromGraphQL(this._gql);
  }
}
